<template>
  <div class="xl:ml-56 xl:mr-28">
    <!-- Hero -->
    <div class="home-wrapper h-full xl:h-screen flex flex-wrap xl:flex-nowrap">
      <!-- Banner -->
      <div
        class="home-banner relative xl:h-full w-screen bg-center bg-cover flex items-end xl:w-1/2"
        :style="{ backgroundImage: 'url(' + settings.banner_hero + ')' }"
        :class="[userAccess ? 'admin' : '']"
      >
        <div
          class="banner-text relative z-10 border-l-8 border-white p-6 pr-8 xl:pr-12 pb-4 mb-12 ml-12 mr-4 xl:mx-12 text-white"
        >
          <h1
            v-if="settings.profile_title && settings.profile_title"
            class="text-white mb-4"
          >
            {{ settings.profile_title }}
          </h1>
          <h4 v-if="settings.profile_sub_title" class="font-secondary mb-4">
            {{ settings.profile_sub_title }}
          </h4>
          <a v-if="settings.profile_description" @click="showReadMore"
            >Read more ></a
          >
        </div>
      </div>

      <div class="h-auto xl:h-full w-screen xl:w-6/12">
        <HomeProfile />
      </div>
    </div>

    <!-- Related exhibitors -->
    <div
      v-if="settings.related_tenants.length > 0"
      class="p-16 bg-truegray-100 home-wrapper"
    >
      <h2 class="mb-12">Related Exhibitors</h2>
      <div
        v-if="loaded"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4"
      >
        <ExhibitorCardGrid
          v-for="(exhibitor, i) in settings.related_tenants.slice(0, 4)"
          :id="exhibitor.id"
          :key="i"
          :ref="'exhibitors-' + i"
          :exhibitor="exhibitor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../../js/plugins/event-bus.js'
import { shared } from '../../../js/mixins/shared.js'
import HomeProfile from './HomeProfile.vue'
import ExhibitorCardGrid from '../../online/components/ExhibitorCardGrid.vue'

export default {
  components: {
    HomeProfile,
    ExhibitorCardGrid,
  },

  mixins: [shared],

  data() {
    return {
      exhibitors: [],

      loaded: true,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      userAccess: 'shared/getUserAccess',
    }),
  },

  methods: {
    showReadMore() {
      EventBus.$emit('showModal', 'read-more')
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 1280px) {
  .home-banner {
    height: calc(100vh - 3rem);
  }
  .home-banner.admin {
    height: calc(100vh - 8rem);
  }
}

@media screen and (min-width: 1280px) {
  .home-wrapper {
    width: calc(100vw - 21.95rem);
  }
}

.banner-text {
  height: fit-content;
}

.home-banner:before {
  position: absolute;
  height: 100%;
  width: 100%;
  content: '';
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.804359243697479) 0%,
    rgba(0, 0, 0, 0) 55%
  );
  z-index: 1;
}
</style>
